<template>
  <div>
    <el-row>
      <el-row class="sj-container">
        <el-table :highlight-current-row="true"
                  :data="table"
                  :show-header="false"
                  border>
          <el-table-column width="150"
                           prop="label">
            <template slot-scope="scope">
              <b>{{scope.row.label}}</b>
            </template>
          </el-table-column>
          <el-table-column min-width="150">
            <template slot-scope="scope">
              <span v-if="ifKey(scope,'believable') || ifKey(scope,'is_super')">
                <span v-if="detailData[scope.row.key] === 1">
                  <el-button type="primary"
                             round
                             disabled
                             size="mini">YES</el-button>
                  <el-button type="info"
                             round
                             disabled
                             size="mini">NO</el-button>
                </span>
                <span v-if="detailData[scope.row.key] === 0">
                  <el-button type="info"
                             round
                             disabled
                             size="mini">YES</el-button>
                  <el-button type="primary"
                             round
                             disabled
                             size="mini">NO</el-button>
                </span>
              </span>
              <span v-if="ifKey(scope,'super_attr')">
                <span v-for="value in detailData[scope.row.key]">
                  <span v-for="option in options[scope.row.key]"
                        v-if="option.id === value">
                    <el-tag>{{option.keyword}}</el-tag>&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>
              </span>
              <span v-if="ifKey(scope,'work_type')">
                  <span v-for="option in options[scope.row.key]"
                        v-if="option.id === detailData[scope.row.key]">
                    <span>{{option.keyword}}</span>
                  </span>
              </span>
              <span v-if="ifKey(scope,'belongto') || ifKey(scope,'referrer_belongto')">
                  <span>{{detailData[scope.row.key]}}</span>
              </span>
              <span v-if="ifKey(scope,'task_all')">
                <div style="color: rgb(88,157,248);">总数量: {{detailData.complete_order_num+detailData.uncomplete_order_num}}</div>
                <div style="color: rgb(88,157,248);">完成数量: {{detailData.complete_order_num}}</div>
                <div style="color: rgb(88,157,248);">退单数量: {{detailData.rejectedTimes}}</div>
              </span>
            </template>
          </el-table-column>
        </el-table>

      </el-row>
    </el-row>
    <layout-panel :show-header="false">
      <div ref="echartMain"
           style="width:100%;height:400px;"></div>
      <div style="text-align:center;font-size:16px">总单数:
        {{detailData.complete_order_num+detailData.uncomplete_order_num}}单
      </div>
      <br/>
      <div style="text-align:center;font-size:16px">退单率: {{refundRate}}%</div>
    </layout-panel>

  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  components: {echarts},
  data () {
    return {
      id: this.$route.query.userid || 0,
      detailData: {
        believable: null,
        is_super: null,
        super_attr: [],
        complete_order_num: 0,
        uncomplete_order_num: 0,
        rejectedTimes: 0,
        work_type: 0,
        belongto: null,
        referrer_belongto: null,
      },
      refundRate: 0,
      table: [
        {
          key: 'believable',
          label: '是否为可信用户',
        },
        {
          key: 'is_super',
          label: '是否为超级零工',
        },
        {
          key: 'super_attr',
          label: '超级零工属性',
        },
        // {
        //   key: 'work_type',
        //   label: '工种',
        // },
        // {
        //   key: 'belongto',
        //   label: '厂家',
        // },
        {
          key: 'referrer_belongto',
          label: '厂家关联',
        },
        {
          key: 'task_all',
          label: '主平台任务总览',
        },
      ],

    }
  },
  created () {
    if (this.id) {
      this.setFormData(this.id)
    }
  },
  computed: Vuex.mapState({
    options: state => state.users.userOptions,
  }),
  methods: {
    ...Vuex.mapActions([]),

    ifKey (scope, name) {
      return scope.row.key === name
    },
    setFormData (id) {
      request.page('getUserOperate', id).then(({data}) => {
        filter.setLoop(this.detailData, data)
        if (this.detailData.complete_order_num + this.detailData.uncomplete_order_num === 0) {
          this.refundRate = 0
        } else {
          this.refundRate = ((this.detailData.rejectedTimes / this.detailData.complete_order_num + this.detailData.uncomplete_order_num) * 100).toFixed(2)
        }


        this.$nextTick(() => {
          this.buildEchart()
        })
      })
    },
    buildEchart () {
      let chart = echarts.init(this.$refs.echartMain)
      let options = {
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}单 <br/>({d}%)',
        },
        legend: {
          data: ['完成数', '未完成'],
        },
        series: [
          {
            type: 'pie',
            data: [
              {
                value: this.detailData.complete_order_num,
                name: '完成数',
                itemStyle: {
                  normal: {color: 'rgb(107,197,254)'},
                },
              },
              {
                value: this.detailData.uncomplete_order_num,
                name: '未完成',
                itemStyle: {
                  normal: {color: 'rgb(255,152,44)'},
                },
              },
            ],
          },
        ],
      }
      chart.setOption(options)
    },
  },
}
</script>
<style lang="scss"
       scoped></style>



// WEBPACK FOOTER //
// src/views/users/pages/detail/UsersOperateDetail.vue